(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.tearsheet
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.tearsheet.largest-investments-at-fair-value.controller
    :refer [largest-investments-by-nav]]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.controller
    :refer [portfolio-locations]]
   [frontend.ui.component.lp-portal.report.tearsheet.return-development.controller
    :refer
    [tvpi]]))

(defn tearsheet
  [{:keys [dynamic-path dynamic-data report-data map-topo] :as props}]
  {:tvpi                        (report-ctl/with-footnote
                                 props
                                 :tvpi-footnotes
                                 (tvpi (get-in report-data [:tearsheet :tvpi])
                                       {}))
   :return-development          (report-ctl/with-footnote
                                 props
                                 :return-development-footnotes
                                 (get-in report-data [:tearsheet :return-development]))
   :largest-investment-by-nav   (merge {:hide? true}
                                       (report-ctl/with-footnote
                                        props
                                        :largest-investments-footnotes
                                        (largest-investments-by-nav
                                         (get-in report-data [:tearsheet :nav-by-properties]))))
   :portfolio-locations         (report-ctl/with-footnote
                                 props
                                 :portfolio-locations-footnotes
                                 (portfolio-locations map-topo (get-in report-data [:chart-data-map])))
   :basic-information-primary   (report-ctl/with-footnote
                                 props
                                 :basic-information-primary-footnotes
                                 (get-in report-data
                                         [:basic-information-primary]))
   :basic-information-secondary (report-ctl/with-footnote
                                 props
                                 :basic-information-secondary-footnotes
                                 (get-in report-data [:basic-information-secondary]))})
